import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from './constants';
import { ManualType } from 'types/manualType';

const url = `${baseApiUrl()}/lexiverse/manual-types/v1/manual-types`;

export const getManualTypes = async (onError?: (errors: ServerErrorResponse) => void) => {
  try {
    const data = await fetcher({
      method: 'get',
      url,
    });
    return data.content || data; // Handle both collection response and direct array
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useManualTypes(options = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<ManualType[], ServerErrorResponse>(['manualTypes'], async () => getManualTypes(onError), {
    keepPreviousData: false,
    ...options,
  });
}
